import { withErrorBoundary } from "@sentry/nextjs";
import { FC, ReactNode, RefObject } from "react";
import styled from "styled-components";
import { ModalPRC, PRCModalOverlay, PRCModalWindow } from "components/ModalPRC";
import { CloseButton } from "./CloseButton";

interface Props {
  ariaLabel: string;
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  focusAfterClose?: RefObject<HTMLElement>;
  onClose: () => void;
  withCloseButton?: boolean;
}

const Modal: FC<Props> = withErrorBoundary(
  ({
    ariaLabel,
    children,
    className = "",
    focusAfterClose = undefined,
    isOpen,
    onClose,
    withCloseButton = undefined,
  }) => {
    return (
      <StyledModal className={className}>
        <ModalPRC isOpen={isOpen} onClose={onClose} focusAfterClose={focusAfterClose}>
          <PRCModalOverlay className="Modal__overlay" />
          <PRCModalWindow className="Modal__window" ariaLabel={ariaLabel}>
            {withCloseButton && <CloseButton className="Modal__closeButton" onClick={onClose} />}
            {children}
          </PRCModalWindow>
        </ModalPRC>
      </StyledModal>
    );
  },
  {}
);

const StyledModal = styled.div`
  .Modal__overlay {
    background: rgb(25 24 23 / 64%);
  }

  .Modal__window {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden auto;
    border-radius: 8px;
    box-shadow: 0 48px 40px -8px rgb(20 20 20 / 12%);
  }

  .Modal__closeButton {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 16px;
    right: 16px;
  }
`;

export { Modal };
